import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { getIsMobileDevice } from 'SRC/modules/common/selectors'
import { AdFilterShowDetailBtn, SelectDropdown, AdFilterField } from 'SRC/ui/FormElementsNew'

export const Field = ({ id, name, value, title, options, onValueChanged, className, isDisabled, isRequired }) => {
	return (
		<AdFilterField className={className}>
			<SelectDropdown
				id={id}
				isDisabled={isDisabled || !options || !options.length}
				isRequired={isRequired}
				title={title}
				options={options}
				value={value}
				onChange={v => {
					onValueChanged(v)
				}}
				isOptional
				isSearchable
			/>
		</AdFilterField>

	)
}

Field.propTypes = {
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	options: PropTypes.array.isRequired,
	className: PropTypes.string,
	isDisabled: PropTypes.bool,
	isRequired: PropTypes.bool,
	onValueChanged: PropTypes.func.isRequired
}

Field.defaultProps = {
	onValueChanged: () => { }
}
